import { isPlatform } from '@ionic/react';
import { ReactElement, useEffect } from 'react';
import { useUnreadNotifications } from '../../api/hooks/event-notifications.hooks';
import { logger } from '../../util/logger';

interface NavigatorBadgeSupport {
  setAppBadge(count: number): Promise<void>;
  clearAppBadge(): Promise<void>;
}

declare global {
  interface Navigator extends NavigatorBadgeSupport {}
}

class PWABadgeService {
  private supported = false;

  constructor() {
    this.supported =
      isPlatform('pwa') &&
      navigator.setAppBadge !== undefined &&
      navigator.clearAppBadge !== undefined;
  }

  public async setBadge(count: number): Promise<void> {
    if (this.supported) {
      try {
        logger.info('setting pwa app badge', { count });
        await navigator.setAppBadge(count);
      } catch (error) {
        logger.error('unable to set notification badge in pwa', {
          count,
          error,
        });
      }
    }
  }
}

const service = new PWABadgeService();

const PWANotificationBadge = (): ReactElement | null => {
  const count = useUnreadNotifications() ?? 0;

  useEffect(() => {
    service.setBadge(count);
  }, [count]);

  return null;
};

export { PWANotificationBadge };
